import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { APP_ENV } from '../tokens/app-environment.token';
import { AppVersionService } from './app-version.service';

@Component({
  selector: 'app-app-update-banner',
  templateUrl: './app-update-banner.component.html',
  styleUrl: './app-update-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateBannerComponent {
  private readonly appEnv = inject(APP_ENV);
  private readonly appVersion = inject(AppVersionService);

  protected readonly enabled = computed(() => this.appEnv.enableAppVersionCheck);
  protected readonly updateAvailable = this.appVersion.updateAvailable;

  protected reload(): void {
    this.appVersion.reloadApp();
  }
}
